const Dashboard = () => import("./dashboard/views/Dashboard.vue");
import TrainingRoutes from "./talent-requisition/routes";
import JobPostingRoutes from "./job-posting/routes";
import TrackingRoutes from "./tracking/routes";
import SettingsRoutes from "./settings/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "talent-requisition",
    redirect: "/admin/recruitment/talent-requisition/talent-request",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: TrainingRoutes,
  },
  {
    path: "job-posting",
    redirect: "/admin/recruitment/job-posting/job-post-request",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: JobPostingRoutes,
  },
  {
    path: "tracking",
    redirect: "/admin/recruitment/tracking/candidate-database",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: TrackingRoutes,
  },
  {
    path: "settings",
    redirect: "/admin/recruitment/settings/recruiter-settings",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: SettingsRoutes,
  },
];
